export const getWidthPrizeInPercent = (total: number) =>
  2 * 50 * Math.sin((Math.PI * (360 / total)) / 180 / 2) + 1;

export const getDegreeOfRotation = (total: number, index?: number) => {
  if (index == null) return 360 / total;
  return (360 / total) * index;
};

export const getOffsetClipPath = (total: number) =>
  Math.ceil(
    (((getWidthPrizeInPercent(total) * 50) /
      Math.floor(
        Math.sqrt(50 ** 2 - (getWidthPrizeInPercent(total) / 2) ** 2)
      ) /
      getWidthPrizeInPercent(total) -
      1.04) *
      100) /
      2
  );
